import DProhServiceProvidersPage from './DProhServiceProvidersPage'

export default DProhServiceProvidersPage
